import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { gsap } from 'gsap';
import './Contact Us.css';
// Import flag images directly from assets (local fallbacks)
import IndiaFlag from '../../assets/images/Contct Us/India.png';
import MalaysiaFlag from '../../assets/images/Contct Us/Malaysia.png';
import UAEFlag from '../../assets/images/Contct Us/UAE.png';
import UKFlag from '../../assets/images/Contct Us/UK.png';
import USAFlag from '../../assets/images/Contct Us/USA.png';
import EgyptFlag from '../../assets/images/Contct Us/Egypt.avif';
import SaudiArabiaFlag from '../../assets/images/Contct Us/Saudi Arabia.jpg';
import SingaporeFlag from '../../assets/images/Contct Us/Singapore.png';
import worldMapImage from '../../assets/images/Contct Us/earth-map.jpg';
import Footer from '../../components/Footer';
import HCaptcha from '@hcaptcha/react-hcaptcha';
// Import config for API URLs
import { config } from '../../utils/config';

const HCAPTCHA_SITEKEY =
  process.env.REACT_APP_HCAPTCHA_SITEKEY ||
  (typeof window !== 'undefined'
    ? (window.__VARDAAN_CONFIG__?.HCAPTCHA_SITEKEY || window.HCAPTCHA_SITEKEY || '')
    : '');
// Import services for caching
import assetService from '../../services/assetService';
import cacheService from '../../services/cacheService';
import { selectSelectedCountry, setSelectedCountry } from '../../store/slices/contactSlice';

// IndexedDB cache keys
const CACHE_KEYS = {
  FLAGS: 'contact_page_flags',
  WORLD_MAP: 'contact_page_world_map'
};

// Country data
const countryData = {
  india: {
    name: 'India',
    flag: IndiaFlag,
    address: [
      'Aurum, 1st Floor, Plot No 57,',
      'Jayabheri Enclave, Gachibowli',
      'Hyderabad-500032 INDIA'
    ],
    // company: 'Vardaan Data Sciences Pvt. Ltd.',
    phone: [],
    email: 'info@vardaanglobal.com',
    mapSrc: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7612.511961535537!2d78.361089!3d17.447458!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb9377a883a6b3%3A0xc9b124e41328f9e9!2sVardaan%20CyberSecurity%20Pvt.%20Ltd.!5e0!3m2!1sen!2sin!4v1702278038269!5m2!1sen!2sin'
  },
  malaysia: {
    name: 'Malaysia',
    flag: MalaysiaFlag,
    address: [
      'Lot G07, Level 3, Platinum Sentral,',
      'Jalan Stesen Sentral 2, 50470,',
      'Kuala Lumpur, MALAYSIA'
    ],
    // company: 'Vardaan CyberSecurity Pvt. Ltd.',
    phone: ['+60327224705', '+601136740107'],
    email: ' info@vardaan-cyber.com',
    mapSrc: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7967.690359288608!2d101.68639800000001!3d3.135571!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31cc49c13d2bd457%3A0xb43f87e8ce95d824!2sSpaces%20-%20Kuala%20Lumpur%2C%20Spaces%20Platinum%20Sentral!5e0!3m2!1sen!2sin!4v1702278406164!5m2!1sen!2sin'
  },
  uae: {
    name: 'UAE',
    flag: UAEFlag,
    address: [
      'Info Drive Risk Management Services LLC,',
      '313, Al Khaleej Center Building,',
      'Mankhool, Dubai (UAE)'
    ],
    // company: 'Vardaan Resources Pvt. Ltd.',
    phone: ['+971 04-2651198'],
    email: 'info@infodriveanalytics.com',
    mapSrc: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7226.239109919306!2d55.156195!3d25.097814!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f6b4164e9f477%3A0x873c65b1c9eb0f7e!2sConcord%20Tower%20-%20Al%20Sufouh%20-%20Al%20Sufouh%202%20-%20Dubai%20-%20United%20Arab%20Emirates!5e0!3m2!1sen!2sin!4v1702278584876!5m2!1sen!2sin'
  },
  uk: {
    name: 'UK',
    flag: UKFlag,
    address: [
      'The Old Courthouse Hughenden Road, High Wycombe,',
      'Buckinghamshire HP13 5DT, UK',
      ''
    ],
    // company: 'Vardaan Data Sciences Pvt. Ltd.',
    phone: ['+44 2071934588', '+44 7404398837'],
    email: 'info_uk@vardaanglobal.com',
    mapSrc: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2476.3833622351713!2d-0.7561062061606544!3d51.6345039992407!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487661d3cc21ae57%3A0x9d8bad2c2975223e!2sThe%20Old%20Courthouse%2C%20Hughenden%20Rd%2C%20High%20Wycombe%20HP13%205DT%2C%20UK!5e0!3m2!1sen!2sin!4v1702278540613!5m2!1sen!2sin'
  },
  usa: {
    name: 'USA',
    flag: USAFlag,
    address: [
      'Vardaan Global INC.',
      '70 Bluebird Ln Ste G, Plainview,',
      'NY, 11803, USA'
    ],
    // company: 'Vardaan Resources Pvt. Ltd.',
    phone: [],
    email: 'info_us@vardaanglobal.com',
    mapSrc: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d6043.108202091877!2d-73.461944!3d40.771831!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89e82a76f743aba1%3A0x2db9df49cfab7646!2s70%20Bluebird%20Ln%20g%2C%20Plainview%2C%20NY%2011803%2C%20USA!5e0!3m2!1sen!2sin!4v1702278621774!5m2!1sen!2sin'
  },
  egypt: {
    name: 'Egypt',
    flag: EgyptFlag,
    address: [
      '14 C American Aid Street, Maadi,',
      '2nd Floor, Office 4',
      'Cairo, EGYPT'
    ],
    // company: 'Vardaan Global',
    phone: [],
    email: 'info@exaliotech.com',
    mapSrc: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3456.123456789!2d31.261944!3d30.072222!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14584093a8b8b8b8%3A0x8b8b8b8b8b8b8b8b!2s14%20C%20American%20Aid%20Street%2C%20Maadi%2C%20Cairo!5e0!3m2!1sen!2sin!4v1702278621774!5m2!1sen!2sin'
  },
  saudiArabia: {
    name: 'Saudi Arabia',
    flag: SaudiArabiaFlag,
    address: [
      'Virtual Technologies,Building no. 8703,',
      'Al Arz Street, Olaya District,',
      'Riyad,Kingdom of Saudi Arabia,12611'
    ],
    // company: 'Vardaan Global',
    phone: [],
    email: 'info@infodriveanalytics.com',
    mapSrc: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3621.123456789!2d46.675278!3d24.713889!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e2f03890d489399%3A0xba964cde78c3f123!2sAl%20Remah%20Tower%2C%20Riyadh!5e0!3m2!1sen!2sin!4v1702278621774!5m2!1sen!2sin'
  },
  singapore: {
    name: 'Singapore',
    flag: SingaporeFlag,
    address: [
      'Singapore'
    ],
    // company: 'Vardaan Global',
    phone: [],
    email: 'info@vardaanglobal.com',
    mapSrc: 'https://www.google.com/maps?q=Singapore&output=embed'
  }
};

// SVG Icons
const EmailIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
    <polyline points="22,6 12,13 2,6"></polyline>
  </svg>
);

const PhoneIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
  </svg>
);

const AddressIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
    <circle cx="12" cy="10" r="3"></circle>
  </svg>
);

// Add new form field icons
const UserIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="form-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
    <circle cx="12" cy="7" r="4"></circle>
  </svg>
);

const SubjectIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="form-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
    <polyline points="14,2 14,8 20,8"></polyline>
    <line x1="16" y1="13" x2="8" y2="13"></line>
    <line x1="16" y1="17" x2="8" y2="17"></line>
    <polyline points="10,9 9,9 8,9"></polyline>
  </svg>
);

const MessageIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="form-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
  </svg>
);

const FormEmailIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="form-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
    <polyline points="22,6 12,13 2,6"></polyline>
  </svg>
);

const FormPhoneIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="form-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
  </svg>
);

function GetInTouch() {
  const dispatch = useDispatch();
  const selectedCountry = useSelector(selectSelectedCountry) || 'india';
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    additionalSubject: '',
    phoneNumber: '',
    phone: '',
    message: '',
    website: '' // honeypot — must stay empty for humans
  });
  const [showDialog, setShowDialog] = useState(false);
  const [showErrorDialog, setShowErrorDialog] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showLoadingModal, setShowLoadingModal] = useState(false);
  const [formSubmitStatus, setFormSubmitStatus] = useState({ success: '', error: '' });
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [privacyAccepted, setPrivacyAccepted] = useState(false);
  const [hcaptchaToken, setHcaptchaToken] = useState(null);
  const hcaptchaRef = useRef(null);
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [warningMessage, setWarningMessage] = useState('');
  const formRenderedAtRef = useRef(Date.now());

  // Cached assets state
  const [cachedFlags, setCachedFlags] = useState({
    india: IndiaFlag,
    malaysia: MalaysiaFlag,
    uae: UAEFlag,
    uk: UKFlag,
    usa: USAFlag,
    egypt: EgyptFlag,
    saudiArabia: SaudiArabiaFlag,
    singapore: SingaporeFlag
  });
  const [cachedWorldMap, setCachedWorldMap] = useState(worldMapImage);
  
  // Preload world map and flag images immediately for instant display
  useEffect(() => {
    // Preload world map
    const mapImg = new Image();
    mapImg.src = worldMapImage;
    if (mapImg.decode) {
      mapImg.decode().catch(() => {});
    }

    // Preload all flags
    const flags = [IndiaFlag, MalaysiaFlag, UAEFlag, UKFlag, USAFlag, EgyptFlag, SaudiArabiaFlag, SingaporeFlag];
    flags.forEach(flag => {
      if (flag) {
        const img = new Image();
        img.src = flag;
        if (img.decode) {
          img.decode().catch(() => {});
        }
      }
    });
  }, []);
  
  // Add refs for the world map
  const containerRef = useRef(null);
  const mapRef = useRef(null);

  // Company locations with coordinates (x and y percentages on the map)
  // Coordinates based on accurate world map positioning
  const locations = [
    { name: 'India', x: 74, y: 37, color: '#ff5722' },        // Central India
    { name: 'Malaysia', x: 81, y: 46, color: '#4caf50' },     // Kuala Lumpur, Malaysia
    { name: 'USA', x: 22, y: 26, color: '#2196f3' },         // Central USA
    { name: 'UK', x: 50, y: 21, color: '#9c27b0' },          // London, UK
    { name: 'UAE', x: 66, y: 37, color: '#ffc107' },         // Dubai, UAE
    { name: 'Egypt', x: 59, y: 35, color: '#e91e63' },       // Cairo, Egypt
    { name: 'Saudi Arabia', x: 63, y: 38, color: '#00bcd4' }, // Riyadh, Saudi Arabia
    { name: 'Singapore', x: 82, y: 50, color: '#009688' }    // Singapore
  ];

  // Load assets from IndexedDB cache first, then update from S3 in background
  useEffect(() => {
    const loadAssetsFromCache = async () => {
      try {
        console.log('📦 Contact Page: Loading assets from IndexedDB cache...');
        
        // Try to load flags from cache
        const cachedFlagsData = await cacheService.getCache(CACHE_KEYS.FLAGS, false);
        if (cachedFlagsData) {
          console.log('✅ Contact Page: Flags loaded from cache');
          setCachedFlags(cachedFlagsData);
        }
        
        // Try to load world map from cache
        const cachedMapData = await cacheService.getCache(CACHE_KEYS.WORLD_MAP, false);
        if (cachedMapData) {
          console.log('✅ Contact Page: World map loaded from cache');
          setCachedWorldMap(cachedMapData);
        }
        
      } catch (error) {
        console.error('❌ Contact Page: Cache load error:', error);
        // Keep using local fallbacks
      }
    };
    
    const updateAssetsCacheFromS3 = async () => {
      try {
        console.log('🌐 Contact Page: Updating assets cache from S3...');
        await assetService.loadS3Assets();
        
        // Load flags from S3 with local fallbacks
        const updatedFlags = {
          india: assetService.getAssetUrl('India.png', IndiaFlag),
          malaysia: assetService.getAssetUrl('Malaysia.png', MalaysiaFlag),
          uae: assetService.getAssetUrl('UAE.png', UAEFlag),
          uk: assetService.getAssetUrl('UK.png', UKFlag),
          usa: assetService.getAssetUrl('USA.png', USAFlag),
          egypt: assetService.getAssetUrl('Egypt.avif', EgyptFlag),
          saudiArabia: assetService.getAssetUrl('Saudi Arabia.jpg', SaudiArabiaFlag),
          singapore: assetService.getAssetUrl('Singapore.png', SingaporeFlag)
        };
        
        // Load world map from S3 with local fallback
        const updatedWorldMap = assetService.getAssetUrl('earth-map.jpg', worldMapImage);
        
        // Update cache
        await cacheService.setCache(CACHE_KEYS.FLAGS, updatedFlags);
        await cacheService.setCache(CACHE_KEYS.WORLD_MAP, updatedWorldMap);
        console.log('💾 Contact Page: Assets cache updated from S3');
        
        // Update UI
        setCachedFlags(updatedFlags);
        setCachedWorldMap(updatedWorldMap);
        
      } catch (error) {
        console.error('❌ Contact Page: Failed to update assets cache from S3:', error);
      }
    };
    
    // Load from cache first (instant), then update from S3 in background
    loadAssetsFromCache();
    updateAssetsCacheFromS3();
  }, []);

  useEffect(() => {
    // Add window resize listener
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    
    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // World Map Effect
  useEffect(() => {
    if (!containerRef.current) return;
    
    const mapContainer = document.createElement('div');
    mapContainer.className = 'map-container';
    mapContainer.style.backgroundImage = `url(${cachedWorldMap})`;
    containerRef.current.appendChild(mapContainer);
    mapRef.current = mapContainer;

    // Add markers and connections for each location
    const markerElements = [];
    const labelElements = [];
    
    locations.forEach((location, index) => {
      // Create marker
      const marker = document.createElement('div');
      marker.className = 'location-marker';
      marker.style.left = `${location.x}%`;
      marker.style.top = `${location.y}%`;
      marker.style.backgroundColor = location.color;
      mapContainer.appendChild(marker);
      markerElements.push(marker);
      
      // Create pulse effect
      const pulse = document.createElement('div');
      pulse.className = 'pulse-effect';
      pulse.style.left = `${location.x}%`;
      pulse.style.top = `${location.y}%`;
      pulse.style.borderColor = location.color;
      mapContainer.appendChild(pulse);
      
      // Animate pulse
      gsap.to(pulse, {
        width: '50px',
        height: '50px',
        opacity: 0,
        duration: 2,
        repeat: -1,
        delay: index * 0.3,
        ease: "power1.out"
      });
      
      // Create label
      const label = document.createElement('div');
      label.className = 'location-label';
      
      // Add specific class for Saudi Arabia to position it below the marker
      if (location.name === 'Saudi Arabia') {
        label.className += ' saudi-arabia-label';
      }
      
      // Add specific class for UAE to position it above the marker
      if (location.name === 'UAE') {
        label.className += ' uae-label';
      }
      
      // Add specific class for Singapore to position it below the marker
      if (location.name === 'Singapore') {
        label.className += ' singapore-label';
      }
      
      label.textContent = location.name;
      label.style.left = `${location.x}%`;
      label.style.top = `${location.y}%`;
      label.style.color = location.color;
      label.style.borderColor = location.color;
      
      mapContainer.appendChild(label);
      labelElements.push(label);
      
      // Animation for markers and labels
      gsap.fromTo(marker, 
        { scale: 0, opacity: 0 },
        { 
          scale: 1, 
          opacity: 1, 
          duration: 0.5, 
          delay: index * 0.2,
          ease: "back.out(1.7)"
        }
      );
      
      gsap.fromTo(label, 
        { y: 20, opacity: 0 },
        { 
          y: 0, 
          opacity: 1, 
          duration: 0.5, 
          delay: index * 0.2 + 0.1,
          ease: "power2.out"
        }
      );
    });
    
    // Create curved connections between locations
    const connections = [
      { from: 4, to: 0, color: '#ffc107' }, // UAE to India
      { from: 4, to: 1, color: '#ffc107' }, // UAE to Malaysia
      { from: 4, to: 2, color: '#ffc107' }, // UAE to USA
      { from: 4, to: 3, color: '#ffc107' }, // UAE to UK
      { from: 4, to: 5, color: '#ffc107' }, // UAE to Egypt
      { from: 4, to: 6, color: '#ffc107' }, // UAE to Saudi Arabia
      { from: 4, to: 7, color: '#ffc107' }, // UAE to Singapore
    ];
    
    connections.forEach((connection, index) => {
      const fromLocation = locations[connection.from];
      const toLocation = locations[connection.to];
      
      // Create a curved SVG path between the two points
      const svgContainer = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      svgContainer.setAttribute("width", "100%");
      svgContainer.setAttribute("height", "100%");
      svgContainer.style.position = "absolute";
      svgContainer.style.top = "0";
      svgContainer.style.left = "0";
      svgContainer.style.zIndex = "2";
      svgContainer.style.pointerEvents = "none";
      mapContainer.appendChild(svgContainer);
      
      // Calculate the curve's control point
      const midX = (fromLocation.x + toLocation.x) / 2;
      let midY = (fromLocation.y + toLocation.y) / 2;
      
      // Adjust the curve height to make a parabola
      const distanceX = Math.abs(fromLocation.x - toLocation.x);
      const distanceY = Math.abs(fromLocation.y - toLocation.y);
      const totalDistance = Math.sqrt(distanceX * distanceX + distanceY * distanceY);
      
      let curveHeight = 10 + (totalDistance / 3);
      
      // Special handling for different routes
      if (connection.to === 2) { // UAE to USA (long distance)
        curveHeight = 25;
      } else if (connection.to === 1) { // UAE to Malaysia
        curveHeight = 15;
      } else if (connection.to === 0) { // UAE to India
        curveHeight = 8;
      } else if (connection.to === 3) { // UAE to UK
        curveHeight = 12;
      } else if (connection.to === 5) { // UAE to Egypt
        curveHeight = 6;
      } else if (connection.to === 6) { // UAE to Saudi Arabia
        curveHeight = 5;
      }
      
      midY -= curveHeight;
      
      // Create the path
      const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
      
      // Use a timeout to ensure the container has proper dimensions
      setTimeout(() => {
        // Get the container dimensions to convert percentages to pixels
        const containerWidth = svgContainer.clientWidth || 1200;
        const containerHeight = svgContainer.clientHeight || 500;
        
        // Convert percentages to absolute pixel values for the SVG path
        const x1 = (fromLocation.x / 100) * containerWidth;
        const y1 = (fromLocation.y / 100) * containerHeight;
        const x2 = (toLocation.x / 100) * containerWidth;
        const y2 = (toLocation.y / 100) * containerHeight;
        const ctrlX = (midX / 100) * containerWidth;
        const ctrlY = (midY / 100) * containerHeight;
        
        // Create the path with absolute pixel coordinates
        const pathD = `M${x1},${y1} Q${ctrlX},${ctrlY} ${x2},${y2}`;
        path.setAttribute("d", pathD);
        path.setAttribute("fill", "none");
        path.setAttribute("stroke", destinationColor);
        path.setAttribute("stroke-width", "2");
        path.setAttribute("opacity", "0.8");
        path.setAttribute("stroke-dasharray", "5,5");
        
        // Animate the path appearance
        try {
          const pathLength = path.getTotalLength();
          if (pathLength) {
            path.style.strokeDasharray = pathLength;
            path.style.strokeDashoffset = pathLength;
            
            gsap.to(path, {
              strokeDashoffset: 0,
              duration: 2,
              delay: index * 0.3,
              ease: "power1.inOut"
            });
            
            // Create moving dot along the path
            const movingDot = document.createElement('div');
            movingDot.className = 'moving-dot';
            movingDot.style.backgroundColor = destinationColor;
            movingDot.style.boxShadow = `0 0 10px ${destinationColor}`;
            mapContainer.appendChild(movingDot);
            
            // Use GSAP for animation
            animateWithGSAP(movingDot, path, destinationColor, index);
          }
        } catch (error) {
          console.error("Error with SVG path:", error);
        }
      }, 100);
      
      // Use the destination country's color for the line
      const destinationColor = locations[connection.to].color;
      svgContainer.appendChild(path);
    });

    // Animation method using GSAP
    function animateWithGSAP(dot, path, color, index) {
      try {
        setTimeout(() => {
          try {
            const pathLength = path.getTotalLength();
            
            if (!pathLength || isNaN(pathLength)) {
              console.warn("Path has invalid length, cannot animate");
              return;
            }
            
            // Set starting position
            const startPos = path.getPointAtLength(0);
            dot.style.left = `${startPos.x}px`;
            dot.style.top = `${startPos.y}px`;
            dot.style.display = 'block';
            
            // Create a progress timeline for the dot
            gsap.to({progress: 0}, {
              progress: 1,
              duration: 4,
              delay: index * 0.5,
              repeat: -1,
              ease: "none",
              onUpdate: function() {
                try {
                  const progress = this.targets()[0].progress;
                  const point = path.getPointAtLength(progress * pathLength);
                  
                  gsap.set(dot, {
                    left: point.x + 'px',
                    top: point.y + 'px'
                  });
                } catch (err) {
                  console.error("Error in animation update:", err);
                }
              }
            });
          } catch (innerError) {
            console.error("Error initializing animation:", innerError);
          }
        }, 100);
      } catch (error) {
        console.error("Animation setup error:", error);
      }
    }

    // Cleanup function
    return () => {
      if (containerRef.current) {
        while (containerRef.current.firstChild) {
          containerRef.current.removeChild(containerRef.current.firstChild);
        }
      }
    };
  }, [cachedWorldMap]); // Re-run when cached world map changes

  // Handle hash navigation to form - scroll directly to contact form
  useEffect(() => {
    // Only run on contact page
    if (location.pathname !== '/contact') {
      return;
    }

    // Function to find and scroll to the form
    const findAndScrollToForm = (attemptNumber = 0) => {
      // Try to find form by ID (works for both mobile and desktop)
      let formElement = document.getElementById('vg-mobile-form');
      
      // If not found by ID, try by class selectors
      if (!formElement) {
        formElement = document.querySelector('.vg-mobile-form') || 
                     document.querySelector('.vg-contact-form-section');
      }
      
      if (formElement) {
        // Check if element has dimensions (is rendered)
        const rect = formElement.getBoundingClientRect();
        const hasDimensions = rect.width > 0 && rect.height > 0;
        
        if (hasDimensions) {
          // Calculate position with navbar offset
          const navbarOffset = 100;
          // Use getBoundingClientRect for more accurate position
          const elementTop = formElement.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementTop - navbarOffset;
          
          // Scroll to form with smooth behavior
          window.scrollTo({
            top: Math.max(0, offsetPosition),
            behavior: 'smooth'
          });
          
          console.log('✅ Successfully scrolled to form at position:', offsetPosition, 'Attempt:', attemptNumber);
          return true;
        } else {
          console.log('⏳ Form element found but not yet rendered, retrying... Attempt:', attemptNumber);
          return false;
        }
      } else {
        console.log('⏳ Form element not found yet, retrying... Attempt:', attemptNumber);
        return false;
      }
    };

    // Check if there's a hash in the URL to scroll to form
    const hash = location.hash || window.location.hash;
    if (hash === '#form' || hash === '#vg-mobile-form') {
      console.log('📍 Hash detected on contact page, will scroll to form...', 'Pathname:', location.pathname);
      
      // Prevent any default scroll to top behavior
      // Scroll to top first, then to form (to ensure we start from top)
      window.scrollTo(0, 0);
      
      // Wait a bit for the page to settle, then scroll to form
      // Use longer delays when navigating from other pages
      const retryDelays = [100, 300, 500, 800, 1200, 1800, 2500, 3500, 5000];
      const timeouts = [];
      let scrollSuccess = false;
      
      retryDelays.forEach((delay, index) => {
        const timeout = setTimeout(() => {
          if (!scrollSuccess) {
            const success = findAndScrollToForm(index);
            if (success) {
              scrollSuccess = true;
              // Clear remaining timeouts
              retryDelays.slice(index + 1).forEach((_, i) => {
                if (timeouts[i + index + 1]) {
                  clearTimeout(timeouts[i + index + 1]);
                }
              });
            }
          }
        }, delay);
        timeouts.push(timeout);
      });
      
      // Also listen for window load event as fallback
      const handleLoad = () => {
        setTimeout(() => {
          if (!scrollSuccess) {
            findAndScrollToForm(999);
          }
        }, 200);
      };
      
      if (document.readyState === 'complete') {
        handleLoad();
      } else {
        window.addEventListener('load', handleLoad);
      }
      
      // Also use requestAnimationFrame for immediate check after render
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (!scrollSuccess) {
            findAndScrollToForm(0);
          }
        });
      });
      
      // Cleanup
      return () => {
        timeouts.forEach(timeout => clearTimeout(timeout));
        window.removeEventListener('load', handleLoad);
      };
    }
  }, [location.hash, location.pathname]); // Run when hash or pathname changes

  const handleCountryChange = (country) => {
    dispatch(setSelectedCountry(country));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Basic client-side validation
    if (!formData.name || !formData.email) {
      alert('Please fill in all required fields (Name and Email)');
      return;
    }
    
    // Basic email format validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      alert('Please enter a valid email address');
      return;
    }
    
    // Check if privacy policy is accepted
    if (!privacyAccepted) {
      alert('Please read and accept the Privacy Policy and Cookie Consent to submit the form');
      return;
    }

    if (HCAPTCHA_SITEKEY && !hcaptchaToken) {
      alert('Please complete the verification challenge.');
      return;
    }
    
    // Reset all modal states first
    setShowModal(false);
    setShowErrorDialog(false);
    setShowDialog(false);
    setShowWarningModal(false);
    
    // Show loading popup immediately
    setShowLoadingModal(true);
    setIsSubmitting(true);
    setFormSubmitStatus({ success: '', error: '' });
    
    // Prepare subject - use additionalSubject if available, otherwise use subject
    const finalSubject = formData.additionalSubject || formData.subject || 'General Inquiry';
    
    // Prepare phone - use phoneNumber if available, otherwise use phone
    const finalPhone = formData.phoneNumber || formData.phone || '';
    
    try {
      console.log('Sending contact form to backend...');
      
      // Prepare form data for backend API
      const contactFormData = {
        name: formData.name,
        email: formData.email,
        subject: finalSubject,
        phone: finalPhone,
        message: formData.message || formData.subject || '',
        hcaptchaToken: hcaptchaToken || '',
        website: formData.website || '',
        formRenderedAt: formRenderedAtRef.current
      };

      // Send to backend API
      const response = await fetch(`${config.CONTACT_API_URL}/api/contact`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(contactFormData)
      });

      const result = await response.json().catch(() => ({}));

      if (response.status === 429) {
        throw new Error(result.error || 'Too many requests. Please wait before trying again.');
      }

      if (!response.ok || !result.success) {
        throw new Error(
          result.error || result.message || 'Unable to process your request. Try again later.'
        );
      }

      console.log('Contact form submitted successfully!');

      setShowLoadingModal(false);
      if (result.flagged) {
        // Spam-flagged: backend stored it in contact_spam and skipped emails.
        setWarningMessage(
          result.message ||
            'Your submission was flagged by our spam filters and has been logged for review.'
        );
        setShowWarningModal(true);
      } else {
        setShowModal(true);
      }

      setFormData({
        name: '',
        email: '',
        subject: '',
        additionalSubject: '',
        phoneNumber: '',
        phone: '',
        message: '',
        website: ''
      });
      formRenderedAtRef.current = Date.now();

      setHcaptchaToken(null);
      try {
        hcaptchaRef.current?.resetCaptcha();
      } catch (e) {
        /* ignore */
      }

      setPrivacyAccepted(false);
      setFormSubmitStatus({ success: '', error: '' });
      
    } catch (error) {
      console.error('Error submitting contact form:', error);
      
      // Hide loading popup immediately on error
      setShowLoadingModal(false);
      
      setFormSubmitStatus({
        success: '',
        error: error.message || 'Failed to send email. Please check your internet connection and try again.'
      });
      
    } finally {
      setIsSubmitting(false);
    }
  };

  // Current country data
  const currentCountry = countryData[selectedCountry];
  
  // Mobile view check
  const isMobile = windowWidth <= 768;

  return (
    <div className="get-in-touch-container">
      {/* World Map Hero Banner */}
      <div className="global-presence-section">
        <h1 className="global-presence-title">
          {/* <span className="title-dark">Contact</span> <span className="title-highlight">Us</span> */}
        </h1>
        
        <div className="world-map-container" ref={containerRef}>
        </div>
      </div>
      
      {!isMobile ? (
        <div className="contactpage-container">
          {/* Location Cards with integrated maps */}
          <div className="location-cards">
            {/* First row - Four cards (India, Malaysia, UAE, UK) */}
            <div className="card-row first-row">
              <div className="office-card india-card" onClick={() => handleCountryChange('india')}>
                {/* Card contents */}
                <img 
                  src={cachedFlags.india} 
                  alt={`${countryData['india'].name} Flag`} 
                  className="card-flag"
                />
                
                <div className="office-details">
                  <div className="office-title">
                    {countryData['india'].name}
                  </div>
                  
                  <div className="company-name">
                    <h3>{countryData['india'].company}</h3>
                  </div>
                  
                  <div className="address-info">
                    {countryData['india'].address.map((line, index) => (
                      <p key={index}>{line}</p>
                    ))}
                  </div>
                  
                  <div className="office-contact-info">
                    <div className="office-contact-item">
                      <EmailIcon />
                      <p>{countryData['india'].email}</p>
                    </div>
                    
                    {countryData['india'].phone.map((number, index) => (
                      <div key={index} className="office-contact-item">
                        <PhoneIcon />
                        <p>{number}</p>
                      </div>
                    ))}
                  </div>
                </div>
                
                <div className="card-map-container">
                  <div className="card-map-header">
                    <img 
                      src={cachedFlags.india} 
                      alt={`${countryData['india'].name} Flag`} 
                      className="card-flag"
                    />
                    <h3 className="card-map-title">{countryData['india'].name}</h3>
                  </div>
                  <div className="card-map-frame">
                    <iframe 
                      src={countryData['india'].mapSrc}
                      allowFullScreen="" 
                      loading="eager"
                  fetchPriority="high"
                  decoding="async"
                      referrerPolicy="no-referrer-when-downgrade"
                      title={`${countryData['india'].name} Office Location`}
                    />
                  </div>
                </div>
              </div>

              <div className="office-card malaysia-card" onClick={() => handleCountryChange('malaysia')}>
                {/* Card contents */}
                <img 
                  src={cachedFlags.malaysia} 
                  alt={`${countryData['malaysia'].name} Flag`} 
                  className="card-flag"
                />
                
                <div className="office-details">
                  <div className="office-title">
                    {countryData['malaysia'].name}
                  </div>
                  
                  <div className="company-name">
                    <h3>{countryData['malaysia'].company}</h3>
                  </div>
                  
                  <div className="address-info">
                    {countryData['malaysia'].address.map((line, index) => (
                      <p key={index}>{line}</p>
                    ))}
                  </div>
                  
                  <div className="office-contact-info">
                    <div className="office-contact-item">
                      <EmailIcon />
                      <p>{countryData['malaysia'].email}</p>
                    </div>
                    
                    {countryData['malaysia'].phone.map((number, index) => (
                      <div key={index} className="office-contact-item">
                        <PhoneIcon />
                        <p>{number}</p>
                      </div>
                    ))}
                  </div>
                </div>
                
                <div className="card-map-container">
                  <div className="card-map-header">
                    <img 
                      src={cachedFlags.malaysia} 
                      alt={`${countryData['malaysia'].name} Flag`} 
                      className="card-flag"
                    />
                    <h3 className="card-map-title">{countryData['malaysia'].name}</h3>
                  </div>
                  <div className="card-map-frame">
                    <iframe 
                      src={countryData['malaysia'].mapSrc}
                      allowFullScreen="" 
                      loading="eager"
                  fetchPriority="high"
                  decoding="async"
                      referrerPolicy="no-referrer-when-downgrade"
                      title={`${countryData['malaysia'].name} Office Location`}
                    />
                  </div>
                </div>
              </div>

              <div className="office-card uae-card" onClick={() => handleCountryChange('uae')}>
                {/* Card contents */}
                <img 
                  src={cachedFlags.uae} 
                  alt={`${countryData['uae'].name} Flag`} 
                  className="card-flag"
                />
                
                <div className="office-details">
                  <div className="office-title">
                    {countryData['uae'].name}
                  </div>
                  
                  <div className="company-name">
                    <h3>{countryData['uae'].company}</h3>
                  </div>
                  
                  <div className="address-info">
                    {countryData['uae'].address.map((line, index) => (
                      <p key={index}>{line}</p>
                    ))}
                  </div>
                  
                  <div className="office-contact-info">
                    <div className="office-contact-item">
                      <EmailIcon />
                      <p>{countryData['uae'].email}</p>
                    </div>
                    
                    {countryData['uae'].phone.map((number, index) => (
                      <div key={index} className="office-contact-item">
                        <PhoneIcon />
                        <p>{number}</p>
                      </div>
                    ))}
                  </div>
                </div>
                
                <div className="card-map-container">
                  <div className="card-map-header">
                    <img 
                      src={cachedFlags.uae} 
                      alt={`${countryData['uae'].name} Flag`} 
                      className="card-flag"
                    />
                    <h3 className="card-map-title">{countryData['uae'].name}</h3>
                  </div>
                  <div className="card-map-frame">
                    <iframe 
                      src={countryData['uae'].mapSrc}
                      allowFullScreen="" 
                      loading="eager"
                  fetchPriority="high"
                  decoding="async"
                      referrerPolicy="no-referrer-when-downgrade"
                      title={`${countryData['uae'].name} Office Location`}
                    />
                  </div>
                </div>
              </div>

              <div className="office-card uk-card" onClick={() => handleCountryChange('uk')}>
                {/* Card contents */}
                <img 
                  src={cachedFlags.uk} 
                  alt={`${countryData['uk'].name} Flag`} 
                  className="card-flag"
                />
                
                <div className="office-details">
                  <div className="office-title">
                    {countryData['uk'].name}
                  </div>
                  
                  <div className="company-name">
                    <h3>{countryData['uk'].company}</h3>
                  </div>
                  
                  <div className="address-info">
                    {countryData['uk'].address.map((line, index) => (
                      <p key={index}>{line}</p>
                    ))}
                  </div>
                  
                  <div className="office-contact-info">
                    <div className="office-contact-item">
                      <EmailIcon />
                      <p>{countryData['uk'].email}</p>
                    </div>
                    
                    {countryData['uk'].phone.map((number, index) => (
                      <div key={index} className="office-contact-item">
                        <PhoneIcon />
                        <p>{number}</p>
                      </div>
                    ))}
                  </div>
                </div>
                
                <div className="card-map-container">
                  <div className="card-map-header">
                    <img 
                      src={cachedFlags.uk} 
                      alt={`${countryData['uk'].name} Flag`} 
                      className="card-flag"
                    />
                    <h3 className="card-map-title">{countryData['uk'].name}</h3>
                  </div>
                  <div className="card-map-frame">
                    <iframe 
                      src={countryData['uk'].mapSrc}
                      allowFullScreen="" 
                      loading="eager"
                  fetchPriority="high"
                  decoding="async"
                      referrerPolicy="no-referrer-when-downgrade"
                      title={`${countryData['uk'].name} Office Location`}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Second row - Three cards (USA, Egypt, Saudi Arabia) */}
            <div className="card-row second-row">
              <div className="office-card usa-card" onClick={() => handleCountryChange('usa')}>
                {/* Card contents */}
                <img 
                  src={cachedFlags.usa} 
                  alt={`${countryData['usa'].name} Flag`} 
                  className="card-flag"
                />
                
                <div className="office-details">
                  <div className="office-title">
                    {countryData['usa'].name}
                  </div>
                  
                  <div className="company-name">
                    <h3>{countryData['usa'].company}</h3>
                  </div>
                  
                  <div className="address-info">
                    {countryData['usa'].address.map((line, index) => (
                      <p key={index}>{line}</p>
                    ))}
                  </div>
                  
                  <div className="office-contact-info">
                    <div className="office-contact-item">
                      <EmailIcon />
                      <p>{countryData['usa'].email}</p>
                    </div>
                    
                    {countryData['usa'].phone.map((number, index) => (
                      <div key={index} className="office-contact-item">
                        <PhoneIcon />
                        <p>{number}</p>
                      </div>
                    ))}
                  </div>
                </div>
                
                <div className="card-map-container">
                  <div className="card-map-header">
                    <img 
                      src={cachedFlags.usa} 
                      alt={`${countryData['usa'].name} Flag`} 
                      className="card-flag"
                    />
                    <h3 className="card-map-title">{countryData['usa'].name}</h3>
                  </div>
                  <div className="card-map-frame">
                    <iframe 
                      src={countryData['usa'].mapSrc}
                      allowFullScreen="" 
                      loading="eager"
                  fetchPriority="high"
                  decoding="async"
                      referrerPolicy="no-referrer-when-downgrade"
                      title={`${countryData['usa'].name} Office Location`}
                    />
                  </div>
                </div>
              </div>

              <div className="office-card egypt-card" onClick={() => handleCountryChange('egypt')}>
                {/* Card contents */}
                <img 
                  src={cachedFlags.egypt} 
                  alt={`${countryData['egypt'].name} Flag`} 
                  className="card-flag"
                />
                
                <div className="office-details">
                  <div className="office-title">
                    {countryData['egypt'].name}
                  </div>
                  
                  <div className="company-name">
                    <h3>{countryData['egypt'].company}</h3>
                  </div>
                  
                  <div className="address-info">
                    {countryData['egypt'].address.map((line, index) => (
                      <p key={index}>{line}</p>
                    ))}
                  </div>
                  
                  <div className="office-contact-info">
                    <div className="office-contact-item">
                      <EmailIcon />
                      <p>{countryData['egypt'].email}</p>
                    </div>
                    
                    {countryData['egypt'].phone.map((number, index) => (
                      <div key={index} className="office-contact-item">
                        <PhoneIcon />
                        <p>{number}</p>
                      </div>
                    ))}
                  </div>
                </div>
                
                <div className="card-map-container">
                  <div className="card-map-header">
                    <img 
                      src={cachedFlags.egypt} 
                      alt={`${countryData['egypt'].name} Flag`} 
                      className="card-flag"
                    />
                    <h3 className="card-map-title">{countryData['egypt'].name}</h3>
                  </div>
                  <div className="card-map-frame">
                    <iframe 
                      src={countryData['egypt'].mapSrc}
                      allowFullScreen="" 
                      loading="eager"
                  fetchPriority="high"
                  decoding="async"
                      referrerPolicy="no-referrer-when-downgrade"
                      title={`${countryData['egypt'].name} Office Location`}
                    />
                  </div>
                </div>
              </div>

              <div className="office-card saudi-arabia-card" onClick={() => handleCountryChange('saudiArabia')}>
                {/* Card contents */}
                <img 
                  src={cachedFlags.saudiArabia} 
                  alt={`${countryData['saudiArabia'].name} Flag`} 
                  className="card-flag"
                />
                
                <div className="office-details">
                  <div className="office-title">
                    {countryData['saudiArabia'].name}
                  </div>
                  
                  <div className="company-name">
                    <h3>{countryData['saudiArabia'].company}</h3>
                  </div>
                  
                  <div className="address-info">
                    {countryData['saudiArabia'].address.map((line, index) => (
                      <p key={index}>{line}</p>
                    ))}
                  </div>
                  
                  <div className="office-contact-info">
                    <div className="office-contact-item">
                      <EmailIcon />
                      <p>{countryData['saudiArabia'].email}</p>
                    </div>
                    
                    {countryData['saudiArabia'].phone.map((number, index) => (
                      <div key={index} className="office-contact-item">
                        <PhoneIcon />
                        <p>{number}</p>
                      </div>
                    ))}
                  </div>
                </div>
                
                <div className="card-map-container">
                  <div className="card-map-header">
                    <img 
                      src={cachedFlags.saudiArabia} 
                      alt={`${countryData['saudiArabia'].name} Flag`} 
                      className="card-flag"
                    />
                    <h3 className="card-map-title">{countryData['saudiArabia'].name}</h3>
                  </div>
                  <div className="card-map-frame">
                    <iframe 
                      src={countryData['saudiArabia'].mapSrc}
                      allowFullScreen="" 
                      loading="eager"
                  fetchPriority="high"
                  decoding="async"
                      referrerPolicy="no-referrer-when-downgrade"
                      title={`${countryData['saudiArabia'].name} Office Location`}
                    />
                  </div>
                </div>
              </div>

              <div className="office-card singapore-card" onClick={() => handleCountryChange('singapore')}>
                {/* Card contents */}
                <img 
                  src={cachedFlags.singapore} 
                  alt={`${countryData['singapore'].name} Flag`} 
                  className="card-flag"
                />
                
                <div className="office-details">
                  <div className="office-title">
                    {countryData['singapore'].name}
                  </div>
                  
                  <div className="company-name">
                    <h3>{countryData['singapore'].company}</h3>
                  </div>
                  
                  <div className="address-info">
                    {countryData['singapore'].address.map((line, index) => (
                      <p key={index}>{line}</p>
                    ))}
                  </div>
                  
                  <div className="office-contact-info">
                    <div className="office-contact-item">
                      <EmailIcon />
                      <p>{countryData['singapore'].email}</p>
                    </div>
                    
                    {countryData['singapore'].phone.map((number, index) => (
                      <div key={index} className="office-contact-item">
                        <PhoneIcon />
                        <p>{number}</p>
                      </div>
                    ))}
                  </div>
                </div>
                
                <div className="card-map-container">
                  <div className="card-map-header">
                    <img 
                      src={cachedFlags.singapore} 
                      alt={`${countryData['singapore'].name} Flag`} 
                      className="card-flag"
                    />
                    <h3 className="card-map-title">{countryData['singapore'].name}</h3>
                  </div>
                  <div className="card-map-frame">
                    <iframe 
                      src={countryData['singapore'].mapSrc}
                      allowFullScreen="" 
                      loading="eager"
                  fetchPriority="high"
                  decoding="async"
                      referrerPolicy="no-referrer-when-downgrade"
                      title={`${countryData['singapore'].name} Office Location`}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Contact Form */}
          <div id="vg-mobile-form" className="vg-contact-form-section">
            <h2 className="vg-contact-title">Contact Us</h2>
            
            <div className="vg-form-container">
              <form onSubmit={handleSubmit} className="vg-contact-form">
                {/* Honeypot trap: hidden from real users, bots auto-fill it */}
                <div className="vg-honeypot-field" aria-hidden="true">
                  <label htmlFor="vg-website">Website</label>
                  <input
                    type="text"
                    id="vg-website"
                    name="website"
                    value={formData.website || ''}
                    onChange={handleInputChange}
                    tabIndex={-1}
                    autoComplete="off"
                    className="vg-form-input"
                  />
                </div>
                <div className="vg-form-row">
                  <div className="vg-form-field">
                    <div className="vg-input-with-icon">
                      <UserIcon />
                      <input 
                        type="text" 
                        name="name" 
                        placeholder="Your Name" 
                        value={formData.name}
                        onChange={handleInputChange}
                        required
                        className="vg-form-input"
                      />
                    </div>
                  </div>
                  <div className="vg-form-field">
                    <div className="vg-input-with-icon">
                      <FormEmailIcon />
                      <input 
                        type="email" 
                        name="email" 
                        placeholder="Your Email" 
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                        className="vg-form-input"
                      />
                    </div>
                  </div>
                </div>
                
                <div className="vg-form-row">
                  <div className="vg-form-field">
                    <div className="vg-input-with-icon">
                      <SubjectIcon />
                      <input 
                        type="text" 
                        name="additionalSubject" 
                        placeholder="Subject" 
                        value={formData.additionalSubject}
                        onChange={handleInputChange}
                        required
                        className="vg-form-input"
                      />
                    </div>
                  </div>
                  <div className="vg-form-field">
                    <div className="vg-input-with-icon">
                      <FormPhoneIcon />
                      <input 
                        type="tel" 
                        name="phoneNumber" 
                        placeholder="Phone number" 
                        value={formData.phoneNumber}
                        onChange={handleInputChange}
                        className="vg-form-input"
                      />
                    </div>
                  </div>
                </div>
                
                <div className="vg-form-row vg-full-width">
                  <div className="vg-form-field">
                    <div className="vg-input-with-icon">
                      <MessageIcon />
                      <textarea 
                        name="subject" 
                        placeholder="Your Preferred time to contact and any specific inputs to clarify"
                        value={formData.subject}
                        onChange={handleInputChange}
                        required
                        className="vg-form-textarea"
                      />
                    </div>
                  </div>
                </div>
                
                <div className="vg-form-row vg-full-width">
                  <div className="vg-privacy-checkbox-container">
                    <input 
                      type="checkbox" 
                      id="privacyConsent" 
                      checked={privacyAccepted}
                      onChange={(e) => setPrivacyAccepted(e.target.checked)}
                      className="vg-privacy-checkbox"
                      required
                    />
                    <label htmlFor="privacyConsent" className="vg-privacy-label">
                      I have read and accept the{' '}
                      <a href="/privacy-policy" target="_blank" rel="noopener noreferrer" className="vg-privacy-link">
                        Privacy Policy
                      </a>
                      {' '}and{' '}
                      <a href="/cookie-policy" target="_blank" rel="noopener noreferrer" className="vg-privacy-link">
                        Cookie Consent
                      </a>
                    </label>
                  </div>
                </div>

                {HCAPTCHA_SITEKEY ? (
                  <div className="vg-form-row vg-full-width vg-hcaptcha-wrap">
                    <HCaptcha
                      ref={hcaptchaRef}
                      sitekey={HCAPTCHA_SITEKEY}
                      onVerify={(token) => setHcaptchaToken(token)}
                      onExpire={() => setHcaptchaToken(null)}
                    />
                  </div>
                ) : null}
                
                <button
                  type="submit"
                  className="vg-submit-button"
                  disabled={
                    isSubmitting ||
                    !privacyAccepted ||
                    (HCAPTCHA_SITEKEY ? !hcaptchaToken : false)
                  }
                >
                  {isSubmitting ? 'Submitting...' : 'Submit'}
                </button>
                
                <div className="vg-response-message">
                  <p>We will respond back to you within 2 business days. Alternatively, you may reach out on the above contact numbers.</p>
                </div>
              </form>
            </div>
          </div>
        </div>
      ) : (
        <div className="vg-mobile-container contactpage-container">
          {/* Mobile Implementation - Same as Desktop Cards */}
          <div className="location-cards">
            {/* First row - Four cards (India, Malaysia, UAE, UK) */}
            <div className="card-row first-row">
              <div className="office-card india-card" onClick={() => handleCountryChange('india')}>
                <img 
                  src={cachedFlags.india} 
                  alt={`${countryData['india'].name} Flag`} 
                  className="card-flag"
                />
                <div className="office-details">
                  <div className="office-title">{countryData['india'].name}</div>
                  <div className="company-name"><h3>{countryData['india'].company}</h3></div>
                  <div className="address-info">
                    {countryData['india'].address.map((line, index) => (
                      <p key={index}>{line}</p>
                    ))}
                  </div>
                  <div className="office-contact-info">
                    <div className="office-contact-item">
                      <EmailIcon />
                      <p>{countryData['india'].email}</p>
                    </div>
                    {countryData['india'].phone.map((number, index) => (
                      <div key={index} className="office-contact-item">
                        <PhoneIcon />
                        <p>{number}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="office-card malaysia-card" onClick={() => handleCountryChange('malaysia')}>
                <img 
                  src={cachedFlags.malaysia} 
                  alt={`${countryData['malaysia'].name} Flag`} 
                  className="card-flag"
                />
                <div className="office-details">
                  <div className="office-title">{countryData['malaysia'].name}</div>
                  <div className="company-name"><h3>{countryData['malaysia'].company}</h3></div>
                  <div className="address-info">
                    {countryData['malaysia'].address.map((line, index) => (
                      <p key={index}>{line}</p>
                    ))}
                  </div>
                  <div className="office-contact-info">
                    <div className="office-contact-item">
                      <EmailIcon />
                      <p>{countryData['malaysia'].email}</p>
                    </div>
                    {countryData['malaysia'].phone.map((number, index) => (
                      <div key={index} className="office-contact-item">
                        <PhoneIcon />
                        <p>{number}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="office-card uae-card" onClick={() => handleCountryChange('uae')}>
                <img 
                  src={cachedFlags.uae} 
                  alt={`${countryData['uae'].name} Flag`} 
                  className="card-flag"
                />
                <div className="office-details">
                  <div className="office-title">{countryData['uae'].name}</div>
                  <div className="company-name"><h3>{countryData['uae'].company}</h3></div>
                  <div className="address-info">
                    {countryData['uae'].address.map((line, index) => (
                      <p key={index}>{line}</p>
                    ))}
                  </div>
                  <div className="office-contact-info">
                    <div className="office-contact-item">
                      <EmailIcon />
                      <p>{countryData['uae'].email}</p>
                    </div>
                    {countryData['uae'].phone.map((number, index) => (
                      <div key={index} className="office-contact-item">
                        <PhoneIcon />
                        <p>{number}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="office-card uk-card" onClick={() => handleCountryChange('uk')}>
                <img 
                  src={cachedFlags.uk} 
                  alt={`${countryData['uk'].name} Flag`} 
                  className="card-flag"
                />
                <div className="office-details">
                  <div className="office-title">{countryData['uk'].name}</div>
                  <div className="company-name"><h3>{countryData['uk'].company}</h3></div>
                  <div className="address-info">
                    {countryData['uk'].address.map((line, index) => (
                      <p key={index}>{line}</p>
                    ))}
                  </div>
                  <div className="office-contact-info">
                    <div className="office-contact-item">
                      <EmailIcon />
                      <p>{countryData['uk'].email}</p>
                    </div>
                    {countryData['uk'].phone.map((number, index) => (
                      <div key={index} className="office-contact-item">
                        <PhoneIcon />
                        <p>{number}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Second row - Three cards (USA, Egypt, Saudi Arabia) */}
            <div className="card-row second-row">
              <div className="office-card usa-card" onClick={() => handleCountryChange('usa')}>
                <img 
                  src={cachedFlags.usa} 
                  alt={`${countryData['usa'].name} Flag`} 
                  className="card-flag"
                />
                <div className="office-details">
                  <div className="office-title">{countryData['usa'].name}</div>
                  <div className="company-name"><h3>{countryData['usa'].company}</h3></div>
                  <div className="address-info">
                    {countryData['usa'].address.map((line, index) => (
                      <p key={index}>{line}</p>
                    ))}
                  </div>
                  <div className="office-contact-info">
                    <div className="office-contact-item">
                      <EmailIcon />
                      <p>{countryData['usa'].email}</p>
                    </div>
                    {countryData['usa'].phone.map((number, index) => (
                      <div key={index} className="office-contact-item">
                        <PhoneIcon />
                        <p>{number}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="office-card egypt-card" onClick={() => handleCountryChange('egypt')}>
                <img 
                  src={cachedFlags.egypt} 
                  alt={`${countryData['egypt'].name} Flag`} 
                  className="card-flag"
                />
                <div className="office-details">
                  <div className="office-title">{countryData['egypt'].name}</div>
                  <div className="company-name"><h3>{countryData['egypt'].company}</h3></div>
                  <div className="address-info">
                    {countryData['egypt'].address.map((line, index) => (
                      <p key={index}>{line}</p>
                    ))}
                  </div>
                  <div className="office-contact-info">
                    <div className="office-contact-item">
                      <EmailIcon />
                      <p>{countryData['egypt'].email}</p>
                    </div>
                    {countryData['egypt'].phone.map((number, index) => (
                      <div key={index} className="office-contact-item">
                        <PhoneIcon />
                        <p>{number}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="office-card saudi-arabia-card" onClick={() => handleCountryChange('saudiArabia')}>
                <img 
                  src={cachedFlags.saudiArabia} 
                  alt={`${countryData['saudiArabia'].name} Flag`} 
                  className="card-flag"
                />
                <div className="office-details">
                  <div className="office-title">{countryData['saudiArabia'].name}</div>
                  <div className="company-name"><h3>{countryData['saudiArabia'].company}</h3></div>
                  <div className="address-info">
                    {countryData['saudiArabia'].address.map((line, index) => (
                      <p key={index}>{line}</p>
                    ))}
                  </div>
                  <div className="office-contact-info">
                    <div className="office-contact-item">
                      <EmailIcon />
                      <p>{countryData['saudiArabia'].email}</p>
                    </div>
                    {countryData['saudiArabia'].phone.map((number, index) => (
                      <div key={index} className="office-contact-item">
                        <PhoneIcon />
                        <p>{number}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div className="office-card singapore-card" onClick={() => handleCountryChange('singapore')}>
                <img 
                  src={cachedFlags.singapore} 
                  alt={`${countryData['singapore'].name} Flag`} 
                  className="card-flag"
                />
                <div className="office-details">
                  <div className="office-title">{countryData['singapore'].name}</div>
                  <div className="company-name"><h3>{countryData['singapore'].company}</h3></div>
                  <div className="address-info">
                    {countryData['singapore'].address.map((line, index) => (
                      <p key={index}>{line}</p>
                    ))}
                  </div>
                  <div className="office-contact-info">
                    <div className="office-contact-item">
                      <EmailIcon />
                      <p>{countryData['singapore'].email}</p>
                    </div>
                    {countryData['singapore'].phone.map((number, index) => (
                      <div key={index} className="office-contact-item">
                        <PhoneIcon />
                        <p>{number}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Contact Form */}
          <div id="vg-mobile-form" className="vg-contact-form-section">
            <h2 className="vg-contact-title">Contact Us</h2>
            
            <div className="vg-form-container">
              <form onSubmit={handleSubmit} className="vg-contact-form">
                {/* Honeypot trap: hidden from real users, bots auto-fill it */}
                <div className="vg-honeypot-field" aria-hidden="true">
                  <label htmlFor="vg-website">Website</label>
                  <input
                    type="text"
                    id="vg-website"
                    name="website"
                    value={formData.website || ''}
                    onChange={handleInputChange}
                    tabIndex={-1}
                    autoComplete="off"
                    className="vg-form-input"
                  />
                </div>
                <div className="vg-form-row">
                  <div className="vg-form-field">
                    <div className="vg-input-with-icon">
                      <UserIcon />
                      <input 
                        type="text" 
                        name="name" 
                        placeholder="Your Name" 
                        value={formData.name}
                        onChange={handleInputChange}
                        required
                        className="vg-form-input"
                      />
                    </div>
                  </div>
                  <div className="vg-form-field">
                    <div className="vg-input-with-icon">
                      <FormEmailIcon />
                      <input 
                        type="email" 
                        name="email" 
                        placeholder="Your Email" 
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                        className="vg-form-input"
                      />
                    </div>
                  </div>
                </div>
                
                <div className="vg-form-row">
                  <div className="vg-form-field">
                    <div className="vg-input-with-icon">
                      <SubjectIcon />
                      <input 
                        type="text" 
                        name="additionalSubject" 
                        placeholder="Subject" 
                        value={formData.additionalSubject}
                        onChange={handleInputChange}
                        required
                        className="vg-form-input"
                      />
                    </div>
                  </div>
                  <div className="vg-form-field">
                    <div className="vg-input-with-icon">
                      <FormPhoneIcon />
                      <input 
                        type="tel" 
                        name="phoneNumber" 
                        placeholder="Phone number" 
                        value={formData.phoneNumber}
                        onChange={handleInputChange}
                        className="vg-form-input"
                      />
                    </div>
                  </div>
                </div>
                
                <div className="vg-form-row vg-full-width">
                  <div className="vg-form-field">
                    <div className="vg-input-with-icon">
                      <MessageIcon />
                      <textarea 
                        name="subject" 
                        placeholder="Your Preferred time to contact and any specific inputs to clarify"
                        value={formData.subject}
                        onChange={handleInputChange}
                        required
                        className="vg-form-textarea"
                      />
                    </div>
                  </div>
                </div>
                
                <div className="vg-form-row vg-full-width">
                  <div className="vg-privacy-checkbox-container">
                    <input 
                      type="checkbox" 
                      id="privacyConsent" 
                      checked={privacyAccepted}
                      onChange={(e) => setPrivacyAccepted(e.target.checked)}
                      className="vg-privacy-checkbox"
                      required
                    />
                    <label htmlFor="privacyConsent" className="vg-privacy-label">
                      I have read and accept the{' '}
                      <a href="/privacy-policy" target="_blank" rel="noopener noreferrer" className="vg-privacy-link">
                        Privacy Policy
                      </a>
                      {' '}and{' '}
                      <a href="/cookie-policy" target="_blank" rel="noopener noreferrer" className="vg-privacy-link">
                        Cookie Consent
                      </a>
                    </label>
                  </div>
                </div>

                {HCAPTCHA_SITEKEY ? (
                  <div className="vg-form-row vg-full-width vg-hcaptcha-wrap">
                    <HCaptcha
                      ref={hcaptchaRef}
                      sitekey={HCAPTCHA_SITEKEY}
                      onVerify={(token) => setHcaptchaToken(token)}
                      onExpire={() => setHcaptchaToken(null)}
                    />
                  </div>
                ) : null}
                
                <button
                  type="submit"
                  className="vg-submit-button"
                  disabled={
                    isSubmitting ||
                    !privacyAccepted ||
                    (HCAPTCHA_SITEKEY ? !hcaptchaToken : false)
                  }
                >
                  {isSubmitting ? 'Submitting...' : 'Submit'}
                </button>
                
                <div className="vg-response-message">
                  <p>We will respond back to you within 2 business days. Alternatively, you may reach out on the above contact numbers.</p>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Dialogs */}
      {showDialog && (
        <div className="dialog-overlay" onClick={() => setShowDialog(false)}>
          <div className="dialog" onClick={e => e.stopPropagation()}>
            <p>Thank you! Your message has been successfully submitted to our database. We will respond back to you within 2 business days.</p>
            <button onClick={() => setShowDialog(false)} aria-label="close" className="close-button">✕</button>
          </div>
        </div>
      )}
      
      {showErrorDialog && (
        <div className="dialog-overlay" onClick={() => setShowErrorDialog(false)}>
          <div className="dialog" onClick={e => e.stopPropagation()}>
            <p>Sorry, there was an error submitting your message to our database. Please check your internet connection and try again, or contact us directly using the phone numbers provided.</p>
            <button onClick={() => setShowErrorDialog(false)} aria-label="close" className="close-button">✕</button>
          </div>
        </div>
      )}

      {/* Loading Modal - Only show when loading */}
      {showLoadingModal && (
        <div className="dialog-overlay loading-overlay">
          <div className="dialog loading-dialog" onClick={e => e.stopPropagation()}>
            <div className="loading-icon">
              <div className="spinner"></div>
            </div>
            <h2 className="loading-title">Sending Your Message</h2>
            <p className="loading-message">
              Please wait while we send your email...
              <br/><br/>
              <br/>
             
            </p>
          </div>
        </div>
      )}

      {/* Success Modal - Show when success */}
      {showModal && (
        <div className="dialog-overlay success-overlay" onClick={() => setShowModal(false)}>
          <div className="dialog success-dialog" onClick={e => e.stopPropagation()}>
            <div className="success-icon">
              <svg width="60" height="60" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" fill="#4CAF50"/>
                <path d="M9 12l2 2 4-4" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h2 className="success-title">Thank You!</h2>
            <p className="success-message">
              Your message has been sent successfully! 
              <br/><br/>
              <br/>
              
            </p>
            <div className="success-actions">
              <button onClick={() => setShowModal(false)} className="success-button">
                Got it, thanks!
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Warning Modal - spam-flagged submissions */}
      {showWarningModal && (
        <div className="dialog-overlay" onClick={() => setShowWarningModal(false)}>
          <div className="dialog" onClick={e => e.stopPropagation()}>
            <h2 className="warning-title">Submission Flagged for Review</h2>
            <p>
              {warningMessage ||
                'Your submission was flagged by our spam filters and has been logged for review. If this is a genuine inquiry, please send a mail to Info@vardaanglobal.com.'}
            </p>
            <button onClick={() => setShowWarningModal(false)} className="success-button">
              Got it
            </button>
          </div>
        </div>
      )}

      {/* Error Status Display */}
      {formSubmitStatus.error && (
        <div className="dialog-overlay" onClick={() => setFormSubmitStatus({ success: '', error: '' })}>
          <div className="dialog" onClick={e => e.stopPropagation()}>
            <p>❌ {formSubmitStatus.error}</p>
            <button onClick={() => setFormSubmitStatus({ success: '', error: '' })} aria-label="close" className="close-button">✕</button>
          </div>
        </div>
      )}
      

      <div className="footer-spacing"></div>
      <Footer />
    </div>
  );
}

export default GetInTouch; 